// extracted by mini-css-extract-plugin
export default {"button":"_3nwAn","readMore":"-PVN-","container":"_2VTpZ","mobile-container":"rCxU4","mobileContainer":"rCxU4","wrapper":"OjhpQ","readMoreExtraMargin":"_1FKOR"};